import { ConfigurationItem } from "@shared/types";
import {
  getItemValueType,
  getName,
} from "@shared/features/configuration/utils";
import { useContext, useMemo } from "react";
import { BotStrategiesContext } from "@shared/features/bots/BotForm/Strategies/BotStrategies.context";
import { isSymbol } from "@shared/types/utils";

const useSharedBuiltInStrategyForm = () => {
  const { templateStrategies, templateStrategy, setTemplateStrategy } =
    useContext(BotStrategiesContext)!;

  const options = useMemo(() => {
    return templateStrategies?.map((strategy: ConfigurationItem) => {
      const name = getName(strategy);
      const strategyValueType = parseInt(getItemValueType(strategy));
      return {
        label: name,
        value: strategyValueType,
      };
    });
  }, [templateStrategies]);

  const builtInStrategiesSelectorData = {
    options,
    value: isSymbol(templateStrategy) ? undefined : templateStrategy,
    onChange: setTemplateStrategy,
  };

  return { builtInStrategiesSelectorData };
};

export default useSharedBuiltInStrategyForm;
